"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponQRcodeRequest = void 0;
var CouponQRcodeRequest = /** @class */ (function () {
    function CouponQRcodeRequest() {
    }
    return CouponQRcodeRequest;
}());
exports.CouponQRcodeRequest = CouponQRcodeRequest;
//# sourceMappingURL=couponQRcode.request.js.map